import { Pipe, PipeTransform } from "@angular/core";
import { CardTableOptions } from "../models/card-table-options.model";

@Pipe({
	name: "propertyclean",
})
export class PropertyCleanPipe implements PipeTransform {
	transform(objects: any[], args: CardTableOptions): any[] {
		if (args == null) {
			return objects;
		}
		if (objects) {
			return objects.filter((object) => {
				return !args.propertyRowExclusions.includes(object.key);
			});
		}
	}
}
